export default "__VITE_ASSET__9AV6h097__"